import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { loadSelectedSchool } from 'tio-common/utils/tuition-assistance/application-new-route';
// This is for types. Anything we have custom may show an error.
import type SessionContextService from 'tio-employee/services/session-context';
import type StoreService from 'ember-data/store';
import type TasProgramInstanceModel from 'tio-data/models/tas-program-instance';
import type TasGroupModel from 'tio-data/models/tas-group';

export default class AuthenticatedTasProgramsNewGuidedRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const { programInstance } = this.modelFor('authenticated.tas.programs') as {
      programInstance: TasProgramInstanceModel;
    };

    const selectedSchool = await loadSelectedSchool(programInstance, this.store);

    // tasGroups and activeInstances will be needed for check of mutually exclusive groups
    // and in progress instances of the current template
    const tasGroups = await this.store.query<TasGroupModel>('tas-group', {
      filter: {
        company: this.sessionContext.currentEmployee.company.id,
        flavor: 'TAS.GroupFlavor.MUTUALLY_EXCLUSIVE',
      },
      include: 'tas-groupings.tas-program-template',
    });

    const activeInstances = await this.store.query<TasProgramInstanceModel>(
      'tas-program-instance',
      {
        filter: { employee: this.sessionContext.currentEmployee.id, active: true },
        include: 'tas-program-template',
      }
    );

    try {
      await programInstance.loadHistory();
    } catch (e) {
      // History is non-critical — don't block the route
      console.error('Error loading program instance history', e);
    }

    return {
      activeInstances: activeInstances,
      programInstance: programInstance,
      selectedSchool: selectedSchool,
      tasGroups: tasGroups,
    };
  }
}
